import React from 'react';

const FooterConfig = () => (
  <div className="admin-screen">
    <h1>Footer Config</h1>
    <p>Manage website footer links and copyright info.</p>
  </div>
);

export default FooterConfig;
